<template>
    <div>
    	<img src="../assets/img/detail/jgw/1.jpg" width="100%" />
    	<img src="../assets/img/detail/jgw/2.jpg" width="100%"/>
    	<img src="../assets/img/detail/jgw/3.jpg" width="100%"/>
    	<img src="../assets/img/detail/jgw/4.jpg" width="100%"/>
    	<img src="../assets/img/detail/jgw/5.jpg" width="100%"/>
    	<img src="../assets/img/detail/jgw/6.jpg" width="100%"/>
    	<img src="../assets/img/detail/jgw/7.jpg" width="100%"/>
    	<img src="../assets/img/detail/jgw/8.jpg" width="100%"/>
    	<img src="../assets/img/detail/jgw/9.jpg" width="100%"/>
    	<img src="../assets/img/detail/jgw/10.jpg" width="100%"/>
    	<img src="../assets/img/detail/jgw/11.jpg" width="100%"/>
    </div>
</template>

<script>
    export default {
        name: 'Product_sswm',
        data: function () {
            return {
            }
        },
        mounted: function () {

        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>